<template>
    <div></div>
</template>
<script>
    import userAuthService from '../../request/service/user-auth-service';
    import util from '@/util';
    export default {
        created(){
            this.init();
        },
        methods:{
            init(){
                let jwt = this.$route.params.jwt;
                let prod = this.$route.query.prod;
                userAuthService.validateToken(jwt, prod).then(() => {
                    util.setYKTCache(this);
                }).catch((error) => {
                    console.info(error);
                    let errorUrl = this.$route.query.errorUrl;
                    if(errorUrl){
                        setTimeout(() => {
                            window.location.href = errorUrl;
                        }, 3000);
                    } else {
                        this.$router.push('/error');
                    }
                })
            }
        }
    }
</script>